/**
 * Convert the GraphQL representation of a trigger and its service
 * to be compatible with <StoredField>'s `ingredientsMetadata` prop.
 */
export default function formatIngredientsMetadata(
  trigger,
  queries,
  servicesByModuleName
) {
  return {
    trigger: formatStep(trigger, servicesByModuleName),
    queries: queries.map(q => formatStep(q, servicesByModuleName)),
  }
}

const formatStep = (step, servicesByModuleName) => {
  if (!step) return {}
  return {
    name: step.name,
    ingredients: step.ingredients.map(i => ({
      ...i,
      normalized_name: i.normalized_name,
    })),
    service: {
      name: servicesByModuleName[step.channel_module_name].name,
      background_color: `#${
        servicesByModuleName[step.channel_module_name].brand_color
      }`,
      icon_url:
        servicesByModuleName[step.channel_module_name].lrg_variant_image_url,
      lrg_monochrome_image_url:
        servicesByModuleName[step.channel_module_name].lrg_monochrome_image_url,
    },
  }
}
